import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import PrivateRoute from './PrivateRoute';
import { useDocumentTitle } from '../utils/useDocumentTitle';

// Lazy load all results components
const AdminResultsPage = LazyComponentWithSuspense(() => import('../pages/Results/AdminResultsPage'));
const StudentResultsPage = LazyComponentWithSuspense(() => import('../pages/Results/StudentResultsPage'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));

export const ResultsRoutes = () => {
  useDocumentTitle('Results');
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute accessibleTo={['SUPERADMIN', 'ADMIN', 'CREATOR']} notCoursePage={true}>
            <AdminResultsPage />
          </PrivateRoute>
        }
      />
      <Route path="/my-results" element={<StudentResultsPage />} />
      <Route path="/exam/:examId" element={<AdminResultsPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

